<template>
  <div class="qr-wrap">
    <qrcode-vue :value="value" :size="size" level="H" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'QrCodeDisplay',
  components: { QrcodeVue },
  props: {
    value: { type: String, required: true },
    size: { type: Number, default: 240 }
  }
}
</script>

<style scoped>
.qr-wrap {
  display: inline-flex;
  padding: var(--spacing-base);
  background: #fff;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
}
</style>
